import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SuiteActions } from '../../../../store';
import { StatusIndicator } from '../../../StatusIndicator';
import './ThermostatDetails.css';

export const ThermostatDetails = (props) => {
  const {
    buildingName,
    buildingSection,
    connectionState,
    disconnection,
    direction,
    firstConnection,
    lastDataRetrieval,
    serialNumber,
    thermostatType,
    unitNumber,
  } = props;

  return (
    <div className="thermostat-details">
      <div className="thermostat-details__title">
        <div className="thermostat-details__title-text">Thermostat Details</div>
      </div>
      <div className="thermostat-details__body">
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">Site:</div>
          <div className="thermostat-details__body-item-value">{buildingName}</div>
        </div>
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">Unit:</div>
          <div className="thermostat-details__body-item-value">{unitNumber}</div>
        </div>
        <div className="thermostat-details__body-item thermostat-details__body-item--captialize">
          <div className="thermostat-details__body-item-title">Direction:</div>
          <div className="thermostat-details__body-item-value">{direction}</div>
        </div>
        <div className="thermostat-details__body-item thermostat-details__body-item--captialize">
          <div className="thermostat-details__body-item-title">Building Section:</div>
          <div className="thermostat-details__body-item-value">{buildingSection}</div>
        </div>
        <div className="thermostat-details__body-item thermostat-details__body-item--captialize">
          <div className="thermostat-details__body-item-title">Thermostat Type:</div>
          <div className="thermostat-details__body-item-value">{thermostatType}</div>
        </div>
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">Serial Number:</div>
          <div className="thermostat-details__body-item-value">{serialNumber}</div>
        </div>
        <div className="thermostat-details__body-item thermostat-details__body-item--captialize">
          <div className="thermostat-details__body-item-title">Connection State:</div>
          <div className="thermostat-details__body-item-value">
            <span className="thermostat-details__body-item--margin">
              <StatusIndicator state={connectionState} />
            </span>
            <span>{connectionState}</span>
          </div>
        </div>
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">First Connection:</div>
          <div className="thermostat-details__body-item-value">{firstConnection}</div>
        </div>
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">Last Disconnection:</div>
          <div className="thermostat-details__body-item-value">{disconnection}</div>
        </div>
        <div className="thermostat-details__body-item">
          <div className="thermostat-details__body-item-title">Last Data Retrieval:</div>
          <div className="thermostat-details__body-item-value">{lastDataRetrieval}</div>
        </div>
      </div>
    </div>
  );
};

ThermostatDetails.propTypes = {
  buildingName: PropTypes.string,
  buildingSection: PropTypes.string,
  connectionState: PropTypes.string,
  disconnection: PropTypes.string,
  direction: PropTypes.string,
  firstConnection: PropTypes.string,
  lastDataRetrieval: PropTypes.string,
  serialNumber: PropTypes.string,
  thermostatType: PropTypes.string,
  unitNumber: PropTypes.string,
};

ThermostatDetails.defaultProps = {
  buildingName: '',
  buildingSection: '',
  connectionState: '',
  disconnection: '',
  direction: '',
  firstConnection: '',
  lastDataRetrieval: '',
  serialNumber: '',
  thermostatType: '',
  unitNumber: '',
};

export function mapStateToProps(state) {
  return {
    buildingName: state.buildingReducer.selectedBuilding.name,
    buildingSection: state.suiteReducer.suiteDetails.building_section,
    connectionState: state.suiteReducer.suiteDetails.connection_state,
    direction: state.suiteReducer.suiteDetails.direction,
    disconnection: state.suiteReducer.suiteDetails.disconnection_timestamp,
    firstConnection: state.suiteReducer.suiteDetails.connection_timestamp,
    lastDataRetrieval: state.suiteReducer.suiteDetails.status_update_timestamp,
    selectedSuite: state.suiteReducer.selectedSuite,
    serialNumber: state.suiteReducer.suiteDetails.serial_number,
    thermostatType: state.suiteReducer.suiteDetails.thermostat_type,
    unitNumber: state.suiteReducer.suiteDetails.unit_number,
  };
}

const mapDispatchToProps = {
  getSuiteDetails: SuiteActions.getSuiteDetails,
};

const ThermostatDetailsWithRouter = withRouter(ThermostatDetails);
export const ConnectedThermostatDetailsWithRouter = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThermostatDetailsWithRouter);
